import { render } from "./DeliveryList.vue?vue&type=template&id=baf79c9a&scoped=true"
import script from "./DeliveryList.vue?vue&type=script&lang=js"
export * from "./DeliveryList.vue?vue&type=script&lang=js"

import "./DeliveryList.vue?vue&type=style&index=0&id=baf79c9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baf79c9a"]])

export default __exports__